var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',{staticClass:"my-1"},_vm._l((_vm.topics),function(topic){return _c('v-col',{key:topic.topic_name,staticClass:"py-1 my-0",attrs:{"cols":"12"}},[_c('debate-topic',{attrs:{"topic":topic}})],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }